import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  @media screen and ${breakpoints.tablet.min.sm} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    gap: ${({ theme }) => theme.space["space-4"]};
    margin-bottom: ${({ theme }) => theme.space["space-4"]};
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.space["space-4"]};
    overflow: auto;
    scroll-snap-type: x mandatory;
    scroll-padding-left: ${({ theme }) => theme.space["space-4"]};
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: ${({ theme }) =>
      `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
